<template>
  <div id="tab3">
    <div class="row mt-n4">
      <div class="col-md-12">
        <SectionTitle
          icon="fas fa-address-card"
          content="Datos de Referido"
          container-class="tag-badge-main-info mb-4"
        />
        <SectionTitle
          content="Información de seguimiento"
          :has-line="true"
          class="custom-section-title pr-n5"
        />
        <TrackingInformation :disabled="isReadMode || !canEditTab3" />
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12">
        <div class="mt-4">
          <SectionTitle
            content="Datos personales del niño o joven registrado para la planilla de Registro"
            :has-line="true"
            class="custom-section-title"
          />
        </div>
        <ValidationObserver ref="formRegisterStudent">
          <div class="ml-4 mt-2">
            <icon-view
              :has-border="false"
              icon-color="#fff"
              icon-background="#ff7058"
              icon="fas fa-info"
              title="Datos del Padre"
              variant="custom-icon-view"
            />
          </div>

          <div class="row d-flex justify-item-between pl-2 ml-0 pb-1">
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Nombre del padre:</span>
              </div>

              <ValidationProvider
                v-slot="{ errors }"
                name="nameFather"
                :rules="isFatherRequired ? 'required' : ''"
              >
                <CustomInput2
                  id="txtnameFather"
                  :class="
                    isEditableRegisterForm || canEditRegisteredPersonalData
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  v-model="registerInfo.fatherName"
                  :error="errors[0]"
                  custom-error-msg="El nombre del padre es requerido."
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </ValidationProvider>
            </div>

            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <validation-provider
                v-slot="{ errors }"
                :rules="isFatherRequired ? 'required' : ''"
              >
                <custom-input2
                  v-model="registerInfo.fatherLastName"
                  custom-error-msg="El campo es requerido."
                  :error="errors[0]"
                  label="Primer Apellido:"
                  maxlength="50"
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <custom-input2
                v-model="registerInfo.fatherSecondLastName"
                label="Segundo Apellido:"
                maxlength="50"
                :disabled="
                  !isEditableRegisterForm && !canEditRegisteredPersonalData
                "
              />
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Ocupación del padre:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="fatherOccupation"
                :rules="isFatherRequired ? 'required' : ''"
              >
                <CustomInput2
                  id="txtfatherOccupation"
                  v-model="registerInfo.fatherOccupation"
                  :class="
                    isEditableRegisterForm || canEditRegisteredPersonalData
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  :error="errors[0]"
                  custom-error-msg="La ocupación del padre es requerida."
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  email: 'El campo debe ser un correo electrónico válido.',
                  required: 'El campo es requerido',
                }"
                :rules="{
                  required: isFatherRequired ? true : false,
                  email: true,
                }"
              >
                <custom-input2
                  v-model="registerInfo.fatherEmail"
                  :error="errors[0]"
                  :custom-error-msg="errors[0]"
                  label="Correo Electrónico:"
                  maxlength="250"
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Teléfono del padre:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :custom-messages="{
                  completePhone: 'Se deben completar los números telefónicos.',
                  required: 'El teléfono del padre es requerido.',
                }"
                name="fatherPhoneNumber"
                :rules="isFatherRequired ? 'required|completePhone' : ''"
              >
                <CustomInput2
                  id="txtfatherPhoneNumber"
                  :class="
                    isEditableRegisterForm || canEditRegisteredPersonalData
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  v-model="registerInfo.fatherPhoneNumber"
                  placeholder="xxx-xxx-xxxx"
                  mask-type="Phone"
                  :error="errors[0]"
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-1  ml-3">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="
                isFatherRequired && !canEditRegisteredPersonalData
                  ? 'required'
                  : ''
              "
            >
              <WizardQuestion
                id="qPreQuestionsA"
                :ref="'RefCreateAccountFatherPortal'"
                v-model="registerInfo.createAccountFatherPortal"
                description="¿Desea crear una cuenta en el Portal de Padres?"
                :answer-control-type="1"
                :has-icon="false"
                :force-error="errors[0] != null"
                :hide-icon-box="true"
                error-message="mensaje"
                class="custom-wizard-question"
                :is-disabled="
                  !isEditableRegisterForm && canEditRegisteredPersonalData
                "
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                message="El campo es requerido."
              />
            </ValidationProvider>
          </div>

          <custom-checkbox
            class="ml-4 mt-4"
            text="Marcar como Contacto Primario"
            v-model="registerInfo.fatherIsPrincipal"
            @input="refreshContactPerson()"
            :disabled="
              !isEditableRegisterForm ||
                registerInfo.motherIsPrincipal ||
                custodianModel.isPrincipal
            "
          />

          <custom-error
            v-if="
              validate &&
                isEditableRegisterForm &&
                !registerInfo.fatherIsPrincipal &&
                !registerInfo.motherIsPrincipal &&
                !custodianModel.isPrincipal
            "
            message="El campo es requerido"
            variant="ml-4 no-border"
          />

          <div class="ml-4 mt-5">
            <icon-view
              :has-border="false"
              icon-color="#fff"
              icon-background="#ff7058"
              icon="fas fa-info"
              title="Datos de la Madre"
              variant="custom-icon-view"
            />
          </div>

          <div class="row d-flex justify-item-between pl-2 ml-0 pb-1">
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Nombre de la madre:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="nameMother"
                :rules="isMotherRequired ? 'required' : ''"
              >
                <CustomInput2
                  id="txtmotherName"
                  :class="
                    isEditableRegisterForm || canEditRegisteredPersonalData
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  v-model="registerInfo.motherName"
                  :error="errors[0]"
                  custom-error-msg="El nombre de la madre es requerido."
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <validation-provider
                v-slot="{ errors }"
                :rules="isMotherRequired ? 'required' : ''"
              >
                <custom-input2
                  v-model="registerInfo.motherLastName"
                  custom-error-msg="El campo es requerido."
                  :error="errors[0]"
                  label="Primer Apellido:"
                  maxlength="50"
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <custom-input2
                v-model="registerInfo.motherSecondLastName"
                label="Segundo Apellido:"
                maxlength="50"
                :disabled="
                  !isEditableRegisterForm && !canEditRegisteredPersonalData
                "
              />
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Ocupación de la madre:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="ocupationMother"
                :rules="isMotherRequired ? 'required' : ''"
              >
                <CustomInput2
                  id="txtmotherOccupation"
                  :class="
                    isEditableRegisterForm || canEditRegisteredPersonalData
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  v-model="registerInfo.motherOccupation"
                  :error="errors[0]"
                  custom-error-msg="La ocupación de la madre es requerida."
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  email: 'El campo debe ser un correo electrónico válido.',
                  required: 'El campo es requerido',
                }"
                :rules="{
                  required: isMotherRequired ? true : false,
                  email: true,
                }"
              >
                <custom-input2
                  v-model="registerInfo.motherEmail"
                  :error="errors[0]"
                  :custom-error-msg="errors[0]"
                  label="Correo Electrónico:"
                  maxlength="250"
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Teléfono de la madre:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :custom-messages="{
                  completePhone: 'Se deben completar los números telefónicos.',
                  required: 'El teléfono de la madre es requerido.',
                }"
                name="motherPhoneNumber"
                :rules="isMotherRequired ? 'required|completePhone' : ''"
              >
                <CustomInput2
                  id="txtmotherPhoneNumber"
                  :class="
                    isEditableRegisterForm || canEditRegisteredPersonalData
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  v-model="registerInfo.motherPhoneNumber"
                  mask-type="Phone"
                  placeholder="xxx-xxx-xxxx"
                  :error="errors[0]"
                  :disabled="
                    !isEditableRegisterForm && !canEditRegisteredPersonalData
                  "
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-1 ml-3">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="
                isMotherRequired && !canEditRegisteredPersonalData
                  ? 'required'
                  : ''
              "
            >
              <WizardQuestion
                id="qPreQuestionsA"
                :ref="'RefCreateAccountMotherPortal'"
                v-model="registerInfo.createAccountMotherPortal"
                description="¿Desea crear una cuenta en el Portal de Padres?"
                :answer-control-type="1"
                :has-icon="false"
                :force-error="errors[0] != null"
                :hide-icon-box="true"
                error-message="mensaje"
                class="custom-wizard-question"
                :is-disabled="
                  !isEditableRegisterForm && canEditRegisteredPersonalData
                "
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                message="El campo es requerido."
              />
            </ValidationProvider>
          </div>

          <custom-checkbox
            class="ml-4 mt-4"
            text="Marcar como Contacto Primario"
            v-model="registerInfo.motherIsPrincipal"
            :disabled="
              !isEditableRegisterForm ||
                registerInfo.fatherIsPrincipal ||
                custodianModel.isPrincipal
            "
            @input="refreshContactPerson()"
          />

          <custom-error
            v-if="
              validate &&
                isEditableRegisterForm &&
                !registerInfo.fatherIsPrincipal &&
                !registerInfo.motherIsPrincipal &&
                !custodianModel.isPrincipal
            "
            message="El campo es requerido"
            variant="ml-4 no-border"
          />

          <ContactInformationForm
            ref="custodianForm"
            v-model="custodianModel"
            title="Datos del encargado"
            contactNameLabel="Nombre del encargado"
            contactOcupationLabel="Ocupación del encargado"
            contactPhoneLabel="Teléfono del encargado"
            :hasNullFields="hasNullFields"
            :isCustodianRequired="isCustodianRequired"
            :isMarkedAsPrimaryDisabled="
              !isEditableRegisterForm ||
                registerInfo.fatherIsPrincipal == true ||
                registerInfo.motherIsPrincipal == true
            "
            :validate="validate"
            :canEditRegisteredPersonalData="canEditRegisteredPersonalData"
            @refreshContactPerson="refreshContactPerson"
          />

          <div class="row d-flex justify-item-between pl-2 ml-0 pb-5">
            <div class="col-12 pt-4 pl-0">
              <div class="mt-4 ">
                <SectionTitle content="Dirección Física" :has-line="true" />
              </div>
            </div>
            <div class="col-md-3 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Dirección (Línea 1):</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="'required'"
                :custom-messages="{
                  required: 'La dirección (línea 1) es requerida.',
                }"
                name="txtAdressLine1"
              >
                <CustomInput2
                  id="txtAdressLine1"
                  v-model="registerInfo.physicalAddressLine1"
                  :class="
                    isEditableRegisterForm || canEditAddresses
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  :error="errors[0]"
                  :disabled="!isEditableRegisterForm && !canEditAddresses"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-3 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Dirección (Línea 2):</span>
              </div>
              <CustomInput2
                id="txtAdressLine2"
                v-model="registerInfo.physicalAddressLine2"
                :class="
                  isEditableRegisterForm || canEditAddresses
                    ? 'custom-input-edit'
                    : 'custom-input-read'
                "
                :disabled="!isEditableRegisterForm && !canEditAddresses"
              />
            </div>
            <div class="col-md-3 col-sm-12 mt-3">
              <div class="container-label">
                <span class="label-design">Municipio:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="'required'"
                name="physicalAddressMunicipality"
              >
                <CustomDropDown
                  v-model="registerInfo.physicalAddressMunicipality"
                  id="physicalAddressMunicipality"
                  fieldkey="id"
                  fieldname="name"
                  :options="municipality"
                  :clearable="false"
                  :error="errors[0]"
                  placeholder="Seleccione"
                  custom-error-msg="El municipio es requerido."
                  :disabled="!isEditableRegisterForm && !canEditAddresses"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-2 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Código Postal:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                  numeric,
                  max: 5,
                }"
                name="código postal"
              >
                <CustomInput2
                  v-model="registerInfo.physicalAddressPostalCode"
                  id="physicalAddressPostalCode"
                  :custom-error-msg="
                    registerInfo.physicalAddressPostalCode
                      ? errors[0]
                      : 'El código postal es requerido.'
                  "
                  :type="number"
                  :error="errors[0]"
                  :class="
                    isEditableRegisterForm || canEditAddresses
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  :disabled="!isEditableRegisterForm && !canEditAddresses"
                />
              </ValidationProvider>
            </div>

            <div class="col-12 pt-4 pl-0">
              <div class="mt-4 ">
                <SectionTitle content="Dirección Postal" :has-line="true" />
              </div>
            </div>

            <div class="col-md-3 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Dirección (Línea 1):</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="postalAddressSameAsPhysical ? '' : 'required'"
                :custom-messages="{
                  required: 'La dirección (línea 1) es requerida.',
                }"
                name="txtPostalAdressLine1"
              >
                <CustomInput2
                  id="txtPostalAdressLine1"
                  v-model="registerInfo.postalAddressLine1"
                  :class="
                    isEditableRegisterForm || canEditAddresses
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  :error="errors[0]"
                  :disabled="
                    (!isEditableRegisterForm && !canEditAddresses) ||
                      postalAddressSameAsPhysical
                  "
                />
              </ValidationProvider>
            </div>
            <div class="col-md-3 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Dirección (Línea 2):</span>
              </div>
              <CustomInput2
                v-model="registerInfo.postalAddressLine2"
                id="txtPostalAdressLine2"
                :class="
                  isEditableRegisterForm || canEditAddresses
                    ? 'custom-input-edit'
                    : 'custom-input-read'
                "
                :disabled="
                  (!isEditableRegisterForm && !canEditAddresses) ||
                    postalAddressSameAsPhysical
                "
              />
            </div>
            <div class="col-md-3 col-sm-12 mt-3">
              <div class="container-label">
                <span class="label-design">Municipio:</span>
              </div>
              <CustomDropDown
                v-model="registerInfo.postalAddressMunicipality"
                id="postalAddressMunicipality"
                fieldkey="id"
                fieldname="name"
                :options="municipality"
                :clearable="false"
                placeholder="Seleccione"
                custom-error-msg="Favor de entrar el municipio de la dirección postal."
                :disabled="
                  (!isEditableRegisterForm && !canEditAddresses) ||
                    postalAddressSameAsPhysical
                "
              />
            </div>
            <div class="col-md-2 col-sm-12 mt-3 pt-0">
              <div class="container-label">
                <span class="label-design">Código Postal:</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{
                  numeric,
                  max: 5,
                }"
                name="código postal"
              >
                <CustomInput2
                  v-model="registerInfo.postalAddressPostalCode"
                  id="postalAddressPostalCode"
                  :custom-error-msg="
                    registerInfo.physicalAddressPostalCode
                      ? errors[0]
                      : 'El código postal es requerido.'
                  "
                  :error="errors[0]"
                  :class="
                    isEditableRegisterForm || canEditAddresses
                      ? 'custom-input-edit'
                      : 'custom-input-read'
                  "
                  :disabled="
                    (!isEditableRegisterForm && !canEditAddresses) ||
                      postalAddressSameAsPhysical
                  "
                />
              </ValidationProvider>
            </div>
            <div class="col-md-2 col-sm-12  pt-0">
              <div class="custom-control custom-checkbox checkbox-top-spacing">
                <input
                  type="checkbox"
                  name="postalAddressSameAsPhysical"
                  id="postalAddressSameAsPhysical"
                  :checked="postalAddressSameAsPhysical"
                  v-model="postalAddressSameAsPhysical"
                  class="custom-control-input"
                  :disabled="!isEditableRegisterForm && !canEditAddresses"
                  @change="onChangePostalAddressSameAsPhysical($event)"
                />

                <label
                  for="postalAddressSameAsPhysical"
                  class="custom-control-label font regular"
                >
                  <span><em class="ic-check" /></span>
                  La misma dirección que la física
                </label>
              </div>
            </div>
          </div>
        </ValidationObserver>
        <ValidationObserver ref="formReferral">
          <form ref="referralDataForm" novalidate @submit.prevent="save">
            <div class="">
              <SectionTitle
                content="Indique las necesidades académicas o funcionales que presenta el estudiante y cómo el especialista podría apoyar"
                :has-line="true"
                class="custom-section-title"
              />
            </div>
            <div class="m-3 mb-5">
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100"
                name="razón de referido"
                rules="required"
              >
                <CustomTextArea
                  id="txtReferralReason"
                  v-model="info.referralReasonDescription"
                  class="w-100"
                  :maxlength="500"
                  placeholder="Razón de Referido"
                  required
                  :error="errors[0]"
                  custom-error-msg="Favor de entrar una razón de referido para continuar"
                  :disabled="!canEditReferralReazon"
                />
              </ValidationProvider>
            </div>

            <div class="mt-4">
              <SectionTitle
                content="Información de Persona Contacto"
                :has-line="true"
                class="custom-section-title"
              />
            </div>

            <div>
              <div class="row d-flex justify-item-between pl-2 ml-0">
                <div class="col-md-4 col-sm-12 mt-3 pt-0">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="nombre"
                    rules="required"
                  >
                    <div class="container-label">
                      <span class="label-design">Nombre:</span>
                    </div>
                    <CustomInput2
                      id="txtContactName"
                      v-model="info.contactName"
                      :class="
                        (isReadMode || !canEditTab3) &&
                        !canChangePersonContactInformation &&
                        oldInfo.contactName &&
                        oldInfo.contactName.length > 0
                          ? 'custom-input-read'
                          : 'custom-input-edit'
                      "
                      required
                      :error="errors[0]"
                      custom-error-msg="Favor de entrar un nombre de familiar o persona contacto"
                      :disabled="
                        registerInfo.fatherIsPrincipal ||
                          registerInfo.motherIsPrincipal ||
                          custodianModel.isPrincipal ||
                          ((isReadMode || !canEditTab3) &&
                            !canChangePersonContactInformation &&
                            oldInfo.contactName &&
                            oldInfo.contactName.length > 0)
                      "
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-4 col-sm-12 mt-3 pt-0">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="teléfono"
                    rules="required"
                  >
                    <div class="container-label">
                      <span class="label-design">Teléfono:</span>
                    </div>
                    <CustomInput2
                      id="txtContactTelephone"
                      v-model="info.contactTelephone"
                      mask-type="Phone"
                      :class="
                        (isReadMode || !canEditTab3) &&
                        !canChangePersonContactInformation &&
                        oldInfo.contactTelephone &&
                        oldInfo.contactTelephone.length > 0
                          ? 'custom-input-read'
                          : 'custom-input-edit'
                      "
                      :masked="false"
                      placeholder="(__) __-____"
                      :error="errors[0]"
                      custom-error-msg="Favor de registrar un teléfono para continuar"
                      :disabled="
                        registerInfo.fatherIsPrincipal ||
                          registerInfo.motherIsPrincipal ||
                          custodianModel.isPrincipal ||
                          ((isReadMode || !canEditTab3) &&
                            !canChangePersonContactInformation &&
                            oldInfo.contactTelephone &&
                            oldInfo.contactTelephone.length > 0)
                      "
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-4 col-sm-12 mt-3 d-flex pt-0">
                  <div
                    class="custom-control custom-checkbox checkbox-top-spacing"
                  >
                    <input
                      id="chkReceiveTextMessage"
                      v-model="info.receiveMessageTextFlag"
                      type="checkbox"
                      name="chkReceiveTextMessage"
                      class="custom-control-input"
                      :disabled="
                        (isReadMode || !canEditTab3) &&
                          !canChangePersonContactInformation &&
                          oldInfo.receiveMessageTextFlag &&
                          oldInfo.receiveMessageTextFlag == true
                      "
                      @change="onChangeReceiveMessageTextFlag($event)"
                    />
                    <label
                      for="chkReceiveTextMessage"
                      class="custom-control-label font regular"
                    >
                      <span><em class="ic-check" /></span>
                      Desea recibir mensaje de texto
                    </label>
                  </div>
                </div>
              </div>
              <div class="row d-flex justify-content-between pl-2 ml-0 mb-5">
                <div class="col-md-4 col-sm-12 mt-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="parentesco"
                    rules="required"
                  >
                    <div class="container-label">
                      <span class="label-design">Parentesco:</span>
                    </div>
                    <custom-drop-down
                      id="ddlRelationships"
                      v-model="selectedRelationship"
                      fieldname="name"
                      fieldkey="id"
                      :options="relationships"
                      placeholder="Seleccione"
                      :error="errors[0]"
                      custom-error-msg="Favor de seleccionar un parentesco de otro familiar o persona contacto"
                      :disabled="
                        registerInfo.fatherIsPrincipal ||
                          registerInfo.motherIsPrincipal ||
                          custodianModel.isPrincipal ||
                          ((isReadMode || !canEditTab3) &&
                            !canChangePersonContactInformation &&
                            selectedRelationship &&
                            selectedRelationship.id > -1)
                      "
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-4 col-sm-12 mt-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="email"
                    rules="required"
                  >
                    <div class="container-label">
                      <span class="label-design">Email:</span>
                    </div>
                    <CustomInput2
                      id="txtContactEmail"
                      v-model="info.contactEmail"
                      :class="
                        (isReadMode || !canEditTab3) &&
                        !canChangePersonContactInformation &&
                        (oldInfo.contactEmail &&
                          oldInfo.contactEmail.length > 0) == true
                          ? 'custom-input-read'
                          : 'custom-input-edit'
                      "
                      required
                      :error="errors[0]"
                      custom-error-msg="Favor de entrar un correo electrónico para continuar"
                      :disabled="
                        registerInfo.fatherIsPrincipal ||
                          registerInfo.motherIsPrincipal ||
                          custodianModel.isPrincipal ||
                          ((isReadMode || !canEditTab3) &&
                            !canChangePersonContactInformation &&
                            (oldInfo.contactEmail &&
                              oldInfo.contactEmail.length > 0) == true)
                      "
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-4 col-sm-12 mt-3">
                  <ValidationProvider
                    v-if="info.receiveMessageTextFlag"
                    v-slot="{ errors }"
                    name="proveedor"
                    rules="required"
                  >
                    <div class="container-label">
                      <span class="label-design">Proveedor:</span>
                    </div>
                    <custom-drop-down
                      id="ddlContactProviders"
                      v-model="selectedContactProvider"
                      fieldname="telephoneProviderName"
                      fieldkey="telephoneProviderNo"
                      placeholder="Seleccione"
                      :options="providers"
                      :error="errors[0]"
                      custom-error-msg="Favor de seleccionar el proveedor"
                      :disabled="
                        (isReadMode || !canEditTab3) &&
                          selectedContactProvider &&
                          selectedContactProvider.telephoneProviderNo > 0
                      "
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </form>
          <div class="mt-4">
            <SectionTitle
              content="Información de Evaluación Inicial"
              :has-line="true"
              class="custom-section-title"
            />
          </div>
          <div class="w-100 mt-n3">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="!canEditRegisteredPersonalData ? 'required' : ''"
            >
              <WizardQuestion
                id="qPreQuestionsA"
                :ref="'RefhasInitialEvaluationFlag'"
                v-model="info.hasInitialEvaluationFlag"
                description="¿Este estudiante cuenta con una evaluación vigente, previa, provista al momento de registro?"
                :answer-control-type="1"
                :has-icon="false"
                :force-error="errors[0] != null"
                :hide-icon-box="true"
                error-message="mensaje"
                class="custom-wizard-question"
                :on-change="onChangePreviousValidEvaluation"
                :is-disabled="
                  (isReadMode && studentStatus != 'Registro') || !canEditTab3
                "
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                :message="resources['21084']"
              />
            </ValidationProvider>
          </div>
          <div v-if="info.hasInitialEvaluationFlag == false" class="w-100">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <WizardQuestion
                id="qPreQuestionsB"
                ref="RefhasProblemWithEvaluationTransportationFlag"
                v-model="info.hasProblemWithEvaluationTransportationFlag"
                description="¿El estudiante tiene problemas de transportación para la cita de evaluación inicial?"
                :answer-control-type="1"
                :has-icon="false"
                :force-error="errors[0] != null"
                :hide-icon-box="true"
                :icon="'fa fa-bus'"
                error-message="mensaje"
                class="custom-wizard-question"
                :on-change="onChangeTransportProblems"
                :is-disabled="
                  (isReadMode && studentStatus != 'Registro') || !canEditTab3
                "
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                :message="
                  'Favor de indicar como se solucionó el problema de transportación para la cita de evaluación inicial.'
                "
              />
            </ValidationProvider>
          </div>
          <div
            v-if="
              info.hasInitialEvaluationFlag == false &&
                info.hasProblemWithEvaluationTransportationFlag == true
            "
            class="mt-4"
          >
            <div class="col-12 pl-3">
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100"
                name="como solucionó el problema"
                rules="required"
              >
                <CustomTextArea
                  id="txtProblemSolution"
                  v-model="info.evaluationTransportationSolution"
                  class="w-100"
                  label="¿Cómo se solucionó el problema?"
                  :maxlength="500"
                  placeholder="Escribir aqui"
                  required
                  :error="errors[0]"
                  custom-error-msg="Campo requerido"
                  :disabled="
                    (isReadMode && studentStatus != 'Registro') || !canEditTab3
                  "
                />
              </ValidationProvider>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <FixedBottomSaveButton v-if="isPreRegistred" :offset="200" @click="save" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers(
  '$_student'
);

import { TrackingInformation } from '@/components/student/registry/components/tab3';
import { SectionTitle } from '@/components/pei/shared/';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomInput from '@/components/common/CustomInput';
import CustomInput2 from 'CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import WizardQuestion from '@/components/pei/WizardQuestion';
import Error from '@/components/common/Error';
import mixAlert from '@/mixin/alert.mixin';
import EduEspCode from '@/utils/constants/eduEspCode';
import RegistryTabNumber from '@/utils/constants/student/registryTabNumber';
import FixedBottomSaveButton from '@/components/common/FixedBottomSaveButton';
import resourcesService from '@/services/resources';
import studentService from '@/services/student';
import store from '@/store/index';
import IconView from 'icon-view';
import CustomCheckbox from 'CheckBox';
import CustomRadio from 'custom-radio';
import CustomError from 'custom-error';
import ContactInformationForm from '../components/tab3/ContactInformationForm';
import StudentStatuses from '@/utils/constants/student/studentStatuses';

const GET_REG_STUDENT_REF_INFO = 'api/student/getinforef?regStudentId=';
const GET_EDU_ESP_CODE_PARENT_RELATIONT_TYPE = `api/code/geteduespcodes?codeType=${EduEspCode.ParentRelationType}`;
const GET_EDU_ESP_CODE_TELEPHONE_PROVIDER = 'api/student/TelephoneProviders';
const SAVE_REG_STUDENT_REF_INFO = 'api/student/updateinforef';

const PARENT_TYPE = {
  MOTHER: 328,
  FATHER: 329,
  CUSTODIAN: 335,
};

export default {
  name: 'Tab3',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    TrackingInformation,
    CustomTextArea,
    ValidationProvider,
    CustomInput,
    CustomInput2,
    ValidationObserver,
    CustomDropDown,
    WizardQuestion,
    Error,
    FixedBottomSaveButton,
    IconView,
    CustomCheckbox,
    CustomRadio,
    CustomError,
    ContactInformationForm,
  },
  data() {
    return {
      postalAddressSameAsPhysical: false,
      municipality: [],
      validate: false,
      custodianModel: {
        lastName: null,
        secondLastName: null,
        occupation: null,
        email: null,
        phoneNumber: null,
        createAccountPortal: null,
        isPrincipal: null,
      },
      registerInfo: {
        fatherName: null,
        fatherLastName: null,
        fatherSecondLastName: null,
        fatherEmail: null,
        fatherIsPrincipal: null,
        fatherOccupation: null,
        fatherPhoneNumber: null,
        motherName: null,
        motherLastName: null,
        motherSecondLastName: null,
        motherEmail: null,
        motherIsPrincipal: null,
        motherOccupation: null,
        motherPhoneNumber: null,
        createAccountFatherPortal: null,
        createAccountMotherPortal: null,
        regStudentId: null,
        studentSieId: null,
        physicalAddressLine1: null,
        physicalAddressLine2: null,
        physicalAddressMunicipality: null,
        physicalAddressPostalCode: null,
        postalAddressLine1: null,
        postalAddressLine2: null,
        postalAddressMunicipality: null,
        postalAddressPostalCode: null,
      },
      createAccountParentPortalOptions: [
        { label: 'Si', value: true, check: false },
        { label: 'No', value: false, check: false },
      ],
      postalAddressLine1_stg: null,
      postalAddressLine2_stg: null,
      postalAddressMunicipality_stg: null,
      postalAddressPostalCode_stg: null,
      providers: [],
      relationships: [],
      resources: [],
      oldInfo: {},
      info: {
        referralReasonDescription: '',
        contactName: '',
        contactRelationCode: 0,
        contactTelephone: '',
        contactEmail: '',
        receiveMessageTextFlag: null,
        hasInitialEvaluationFlag: null,
        hasProblemWithEvaluationTransportationFlag: null,
        evaluationTransportationSolution: '',
      },
      selectedRelationship: null,
      selectedContactProvider: null,
      messages: {
        questionRequired: 'Favor de contestar Sí o No para continuar',
      },
      canEditTab3: store.getters.HasPermission('registry.editTab3'),
    };
  },
  watch: {
    canChangePersonContactInformation: {
      handler: function(newValue) {
        if (newValue) {
          this.$emit('set-button-save-visibility', true);
        }
      },
      immediate: true,
    },
    registerInfo: {
      handler() {
        if (this.isPreRegistred) this.refreshContactPerson();
      },
      deep: true,
    },
    custodianModel: {
      handler() {
        if (this.isPreRegistred) this.refreshContactPerson();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState([
      'studentPreRegistryValidations',
      'selectedStudentPreRegistry',
    ]),
    ...mapGetters({
      selectedStudent: 'SelectedStudent',
      selectedPreRegistry: 'getStudentPreRegistry',
    }),
    studentSieId() {
      return parseInt(this.selectedStudent.studentId);
    },
    academyYearId() {
      return this.selectedPreRegistry.academicYearId;
    },
    regStudentId() {
      return this.selectedPreRegistry.regStudentId;
    },
    canChangePersonContactInformation() {
      return store.getters.HasPermission(
        'academic.registry.edit.personcontactinformation'
      );
    },
    canEditReferralReazon() {
      if (!this.canEditTab3) return false;

      const hasEditPermission = store.getters.HasPermission(
        'registry.editreferralreazon'
      );

      const studentStatusesEditableByPermission = [
        StudentStatuses.Registro,
        StudentStatuses.Evaluado,
        StudentStatuses.Servido,
        StudentStatuses.Elegible,
      ];

      const isOnlyEditableByPermission = studentStatusesEditableByPermission.includes(
        this.selectedPreRegistry.statusId
      );
      if (hasEditPermission && isOnlyEditableByPermission) {
        return true;
      }

      const haveValue = this.oldInfo.referralReasonDescription?.length > 0;
      return !this.isReadMode || !haveValue;
    },
    isInvalid() {
      return (
        this.studentPreRegistryValidations.filter(
          (x) => x === RegistryTabNumber.ReferralData
        ).length > 0
      );
    },
    isReadMode() {
      return this.selectedStudentPreRegistry.isReadMode;
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    canEditRegisteredPersonalData() {
      const hasPermission = store.getters.HasPermission(
        'academic.registry.edit.registeredpersonaldata'
      );

      return (
        hasPermission &&
        ['Registro', 'Elegible', 'Servido', 'Evaluado'].includes(
          this.studentStatus
        )
      );
    },
    canEditAddresses() {
      const hasPermission = store.getters.HasPermission(
        'academic.registry.can.edit.address'
      );

      return (
        hasPermission && ['Elegible', 'Servido'].includes(this.studentStatus)
      );
    },
    isEditableRegisterForm() {
      let studentStatus = this.studentStatus;
      return (
        studentStatus != 'No Elegible' &&
        studentStatus != 'Elegible' &&
        studentStatus != 'Servido' &&
        studentStatus != 'Evaluado'
      );
    },
    isPreRegistred() {
      return this.studentStatus === 'Pre-Registro';
    },
    hasNullFields() {
      if (
        (this.registerInfo.fatherName == '' ||
          this.registerInfo.fatherName == null) &&
        (this.registerInfo.fatherOccupation == '' ||
          this.registerInfo.fatherOccupation == null) &&
        (this.registerInfo.fatherPhoneNumber == '' ||
          this.registerInfo.fatherPhoneNumber == null) &&
        (this.registerInfo.fatherLastName == '' ||
          this.registerInfo.fatherLastName == null) &&
        (this.registerInfo.fatherSecondLastName == '' ||
          this.registerInfo.fatherSecondLastName == null) &&
        (this.registerInfo.fatherEmail == '' ||
          this.registerInfo.fatherEmail == null) &&
        (this.registerInfo.createAccountFatherPortal == '' ||
          this.registerInfo.createAccountFatherPortal == null) &&
        (this.registerInfo.motherName == '' ||
          this.registerInfo.motherName == null) &&
        (this.registerInfo.motherOccupation == '' ||
          this.registerInfo.motherOccupation == null) &&
        (this.registerInfo.motherPhoneNumber == '' ||
          this.registerInfo.motherPhoneNumber == null) &&
        (this.registerInfo.motherLastName == '' ||
          this.registerInfo.motherLastName == null) &&
        (this.registerInfo.motherSecondLastName == '' ||
          this.registerInfo.motherSecondLastName == null) &&
        (this.registerInfo.motherEmail == '' ||
          this.registerInfo.motherEmail == null) &&
        (this.registerInfo.createAccountMotherPortal == '' ||
          this.registerInfo.createAccountMotherPortal == null) &&
        this.hasCustodianNullFields
      ) {
        return true;
      }
      return false;
    },
    hasMotherNullFields() {
      if (
        (this.registerInfo.motherName == '' ||
          this.registerInfo.motherName == null) &&
        (this.registerInfo.motherOccupation == '' ||
          this.registerInfo.motherOccupation == null) &&
        (this.registerInfo.motherPhoneNumber == '' ||
          this.registerInfo.motherPhoneNumber == null) &&
        (this.registerInfo.motherLastName == '' ||
          this.registerInfo.motherLastName == null) &&
        (this.registerInfo.motherSecondLastName == '' ||
          this.registerInfo.motherSecondLastName == null) &&
        (this.registerInfo.motherEmail == '' ||
          this.registerInfo.motherEmail == null) &&
        (this.registerInfo.motherIsPrincipal == '' ||
          this.registerInfo.motherIsPrincipal == null) &&
        (this.registerInfo.createAccountMotherPortal == '' ||
          this.registerInfo.createAccountMotherPortal == null)
      ) {
        return false;
      }
      return true;
    },
    hasFatherNullFields() {
      if (
        (this.registerInfo.fatherName == '' ||
          this.registerInfo.fatherName == null) &&
        (this.registerInfo.fatherOccupation == '' ||
          this.registerInfo.fatherOccupation == null) &&
        (this.registerInfo.fatherPhoneNumber == '' ||
          this.registerInfo.fatherPhoneNumber == null) &&
        (this.registerInfo.fatherLastName == '' ||
          this.registerInfo.fatherLastName == null) &&
        (this.registerInfo.fatherSecondLastName == '' ||
          this.registerInfo.fatherSecondLastName == null) &&
        (this.registerInfo.fatherEmail == '' ||
          this.registerInfo.fatherEmail == null) &&
        (this.registerInfo.fatherIsPrincipal == '' ||
          this.registerInfo.fatherIsPrincipal == null) &&
        (this.registerInfo.createAccountFatherPortal == '' ||
          this.registerInfo.createAccountFatherPortal == null)
      ) {
        return false;
      }
      return true;
    },
    hasCustodianNullFields() {
      let result = false;

      // Verificar si los campos del custodiano están vacíos o nulos
      if (
        (this.custodianModel.name == '' || this.custodianModel.name == null) &&
        (this.custodianModel.lastName == '' ||
          this.custodianModel.lastName == null) &&
        (this.custodianModel.secondLastName == '' ||
          this.custodianModel.secondLastName == null) &&
        (this.custodianModel.email == '' ||
          this.custodianModel.email == null) &&
        (this.custodianModel.phone == '' || this.custodianModel.phone == null)
      ) {
        result = true;
      }

      return result;
    },
    isFatherRequired() {
      return (
        (!this.custodianModel.isPrincipal &&
          !this.registerInfo.motherIsPrincipal &&
          this.hasNullFields) ||
        this.hasFatherNullFields
      );
    },
    isMotherRequired() {
      return (
        (!this.custodianModel.isPrincipal &&
          !this.registerInfo.motherIsPrincipal &&
          this.hasNullFields) ||
        this.hasMotherNullFields
      );
    },
    isCustodianRequired() {
      const isOtherRequired = this.isFatherRequired || this.isMotherRequired;

      return (
        !isOtherRequired ||
        (!this.isFatherRequired &&
          !this.isMotherRequired &&
          this.hasCustodianNullFields)
      );
    },
  },
  async activated() {
    this.$store.commit('setSaveMethod', this.save);
    this.$store.commit('setResetOriginalDataMethod', this.discardChanges);

    //if is invalid call save method to raise validations
    if (this.isInvalid) {
      await this.raiseValidate();
    }
  },
  methods: {
    ...mapMutations(['setStudentPreRegistryValidations']),
    async raiseValidate() {
      await this.$refs.formReferral.validate();
      await this.$refs.formRegisterStudent.validate();
    },
    async save() {
      this.validate = true;
      const isValid = await this.$refs.formReferral.validate();
      const isValidFamilyData =
        this.canEditRegisteredPersonalData ||
        (await this.$refs.formRegisterStudent.validate());
      const isValidCheck =
        this.registerInfo.fatherIsPrincipal ||
        this.registerInfo.motherIsPrincipal ||
        this.custodianModel.isPrincipal;

      const validFamilyData =
        (isValidFamilyData && this.isEditableRegisterForm) ||
        (this.canChangePersonContactInformation &&
          !this.isEditableRegisterForm);

      const hasToValidateAddresses =
        this.isEditableRegisterForm || this.canEditAddresses;
      const isValidAddresses =
        (hasToValidateAddresses &&
          (await this.$refs.formRegisterStudent.validate())) ||
        !hasToValidateAddresses;
      if (
        isValid &&
        validFamilyData &&
        (isValidCheck || this.canEditRegisteredPersonalData) &&
        isValidAddresses
      ) {
        if (this.registerInfo.fatherPhoneNumber != null) {
          let fatherNumber = this.registerInfo.fatherPhoneNumber
            .toString()
            .replace(/\D/g, '')
            .toString();
          if (fatherNumber.length < 10 && fatherNumber.length != 0) {
            this.alertNumber();
          } else {
            await this.saveRefInfo();
            this.oldInfo = { ...this.info };
          }
        }

        if (this.registerInfo.motherPhoneNumber != null) {
          let motherNumber = this.registerInfo.motherPhoneNumber
            .toString()
            .replace(/\D/g, '')
            .toString();

          if (motherNumber.length < 10 && motherNumber.length != 0) {
            this.alertNumber();
          } else {
            await this.saveRefInfo();
            this.oldInfo = { ...this.info };
          }
        }

        if (this.custodianModel.phoneNumber != null) {
          let custodianPhoneNumber = this.custodianModel.phoneNumber
            .toString()
            .replace(/\D/g, '')
            .toString();

          if (
            custodianPhoneNumber.length < 10 &&
            custodianPhoneNumber.length != 0
          ) {
            this.alertNumber();
          } else {
            await this.saveRefInfo();
            this.oldInfo = { ...this.info };
          }
        }

        if (
          this.canChangePersonContactInformation &&
          !this.isEditableRegisterForm
        ) {
          await this.saveRefInfo();
        }
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor verificar y completar la información solicitada.',
          'error'
        );
      }
    },
    discardChanges() {},
    onChangePreviousValidEvaluation(item) {
      this.info.hasInitialEvaluationFlag = item.selectedAnswer;
      if (item.selectedAnswer == false) {
        this.info.hasProblemWithEvaluationTransportationFlag = null;
      }
    },
    onChangeTransportProblems(item) {
      this.info.hasProblemWithEvaluationTransportationFlag =
        item.selectedAnswer;
    },
    onChangeReceiveMessageTextFlag() {
      if (this.info.receiveMessageTextFlag) {
        this.getTelephoneProvider();
      } else {
        this.selectedContactProvider = null;
      }
    },
    onChangePostalAddressSameAsPhysical() {
      if (this.postalAddressSameAsPhysical) {
        this.postalAddressPostalCode_stg = this.registerInfo.postalAddressPostalCode;
        this.postalAddressLine1_stg = this.registerInfo.postalAddressLine1;
        this.postalAddressLine2_stg = this.registerInfo.postalAddressLine2;
        this.postalAddressMunicipality_stg = this.registerInfo.postalAddressMunicipality;

        this.registerInfo.postalAddressPostalCode = this.registerInfo.physicalAddressPostalCode;
        this.registerInfo.postalAddressLine1 = this.registerInfo.physicalAddressLine1;
        this.registerInfo.postalAddressLine2 = this.registerInfo.physicalAddressLine2;
        this.registerInfo.postalAddressMunicipality = this.registerInfo.physicalAddressMunicipality;
      } else {
        this.registerInfo.postalAddressPostalCode = this.postalAddressPostalCode_stg;
        this.registerInfo.postalAddressLine1 = this.postalAddressLine1_stg;
        this.registerInfo.postalAddressLine2 = this.postalAddressLine2_stg;
        this.registerInfo.postalAddressMunicipality = this.postalAddressMunicipality_stg;
      }
    },
    alertNumber() {
      this.ShowToast(
        'Información Incompleta',
        'Se deben completar los números telefónicos.',
        'error'
      );
    },
    evalFlag(value) {
      if (value == null || value == undefined) return null;
      return value == '1' ? true : false;
    },
    async getStudentRefInfo() {
      if (this.regStudentId) {
        const { data: refInfo } = await this.$ApiGet(
          `${GET_REG_STUDENT_REF_INFO}${this.regStudentId}`
        );
        if (refInfo) {
          this.info = { ...refInfo };
          //set contact relation type
          this.selectedRelationship =
            this.relationships.filter(
              (x) => x.id === refInfo.contactRelationCode
            )[0] || null;

          //set contact provider
          if (refInfo.receiveMessageTextFlag === true) {
            await this.getTelephoneProvider();
            this.selectedContactProvider =
              this.providers.filter(
                (x) =>
                  x.telephoneProviderNo == refInfo.contactTelephoneProviderCode
              )[0] || null;
          }

          this.$nextTick(() => {
            const _evalHasInitialEvaluationFlag = this.evalFlag(
              refInfo.hasInitialEvaluationFlag
            );
            this.info.hasInitialEvaluationFlag = _evalHasInitialEvaluationFlag;
            this.$refs.RefhasInitialEvaluationFlag.selectedAnswer = _evalHasInitialEvaluationFlag;

            const _evalHasProblemWithEvaluationTransportationFlag = this.evalFlag(
              refInfo.hasProblemWithEvaluationTransportationFlag
            );
            this.info.hasProblemWithEvaluationTransportationFlag = _evalHasProblemWithEvaluationTransportationFlag;

            if (this.$refs.RefhasProblemWithEvaluationTransportationFlag)
              this.$refs.RefhasProblemWithEvaluationTransportationFlag.selectedAnswer = _evalHasProblemWithEvaluationTransportationFlag;
          });

          this.oldInfo = { ...this.info };
        }
      }
    },
    async saveRefInfo() {
      if (this.info) {
        const params = {
          regStudentId: this.regStudentId,
          studentSieId: this.studentSieId,
          academicYearId: this.academyYearId,
          referralReasonDescription: this.info.referralReasonDescription,
          contactName: this.info.contactName,
          contactTelephone: this.info.contactTelephone,
          contactEmail: this.info.contactEmail,
          receiveMessageTextFlag: this.info.receiveMessageTextFlag,
          contactRelationCode: this.selectedRelationship
            ? this.selectedRelationship.id
            : null,
          contactTelephoneProviderCode: this.selectedContactProvider
            ? this.selectedContactProvider.telephoneProviderNo
            : null,
          hasInitialEvaluationFlag:
            this.info.hasInitialEvaluationFlag == null
              ? null
              : this.info.hasInitialEvaluationFlag == '1'
              ? '1'
              : '0',
          hasProblemWithEvaluationTransportationFlag:
            this.info.hasProblemWithEvaluationTransportationFlag == null
              ? null
              : this.info.hasProblemWithEvaluationTransportationFlag == '1'
              ? '1'
              : '0',
          evaluationTransportationSolution: this.info
            .evaluationTransportationSolution,
        };
        const _saved = await this.$ApiPost(
          SAVE_REG_STUDENT_REF_INFO,
          { ...params },
          true
        );

        studentService.saveStudentParentsInformation({
          regStudentId: this.regStudentId,
          fatherName: this.registerInfo.fatherName,
          fatherLastName: this.registerInfo.fatherLastName,
          fatherSecondLastName: this.registerInfo.fatherSecondLastName,
          fatherEmail: this.registerInfo.fatherEmail,
          fatherIsPrincipal: this.registerInfo.fatherIsPrincipal,
          fatherOccupation: this.registerInfo.fatherOccupation,
          fatherPhoneNumber: this.registerInfo.fatherPhoneNumber,
          motherName: this.registerInfo.motherName,
          motherLastName: this.registerInfo.motherLastName,
          motherSecondLastName: this.registerInfo.motherSecondLastName,
          motherEmail: this.registerInfo.motherEmail,
          motherIsPrincipal: this.registerInfo.motherIsPrincipal,
          motherOccupation: this.registerInfo.motherOccupation,
          createAccountFatherPortal: this.registerInfo
            .createAccountFatherPortal,
          createAccountMotherPortal: this.registerInfo
            .createAccountMotherPortal,
          motherPhoneNumber: this.registerInfo.motherPhoneNumber,
          // custodian information
          createAccountCustodianPortal: this.custodianModel.createAccountPortal,
          sieCustodianName: this.custodianModel.name,
          sieCustodianLastName: this.custodianModel.lastName,
          sieCustodianSecondLastName: this.custodianModel.secondLastName,
          sieCustodianOccupation: this.custodianModel.occupation,
          sieCustodianPhoneNumber: this.custodianModel.phoneNumber,
          sieCustodianEmail: this.custodianModel.email,
          sieCustodianIsPrincipal: this.custodianModel.isPrincipal,
          // phisical address
          sieStudentPhysicalAddress: this.getPhysicalAddress(),
          sieStudentPostalAddress: this.postalAddressSameAsPhysical
            ? this.getPhysicalAddress()
            : this.getPostalAddress(),
          physicalAddressLine1: this.registerInfo.physicalAddressLine1,
          physicalAddressLine2: this.registerInfo.physicalAddressLine2,
          physicalAddressMunicipality: this.registerInfo
            .physicalAddressMunicipality?.id,
          physicalAddressPostalCode: this.registerInfo
            .physicalAddressPostalCode,
          postalAddressLine1: this.registerInfo.postalAddressLine1,
          postalAddressLine2: this.registerInfo.postalAddressLine2,
          postalAddressMunicipality: this.registerInfo.postalAddressMunicipality
            ?.id,
          postalAddressPostalCode: this.registerInfo.postalAddressPostalCode,
        });

        if (_saved) {
          this.ShowToast(
            'Notificación',
            'Los datos fueron guardados exitosamente.',
            'success'
          );
          this.clearInvalidFeedback();
        }
      }
    },
    getPhysicalAddress() {
      return `${this.registerInfo.physicalAddressLine1} ${this.registerInfo
        .physicalAddressLine2 ?? ''} ${
        this.registerInfo.physicalAddressMunicipality.name
      }, PR ${this.registerInfo.physicalAddressPostalCode}`.replace(
        /\s+/g,
        ' '
      );
    },
    getPostalAddress() {
      return `${this.registerInfo.postalAddressLine1} ${this.registerInfo
        .postalAddressLine2 ?? ''} ${
        this.registerInfo?.postalAddressMunicipality?.name
      }, PR ${this.registerInfo?.postalAddressPostalCode}`.replace(/\s+/g, ' ');
    },
    async getParentRelationType() {
      const { data: relations } = await this.$ApiGet(
        GET_EDU_ESP_CODE_PARENT_RELATIONT_TYPE
      );
      if (relations) {
        this.relationships = [...relations];
      }
    },
    async getTelephoneProvider() {
      const { data: telephoneProviders } = await this.$ApiGet(
        GET_EDU_ESP_CODE_TELEPHONE_PROVIDER
      );
      if (telephoneProviders) {
        this.providers = telephoneProviders;
      }
    },
    async loadInfo() {
      await this.getParentRelationType();
      await this.getStudentRefInfo();
    },
    clearInvalidFeedback() {
      const _numbers = this.studentPreRegistryValidations.filter(
        (x) => x !== RegistryTabNumber.ReferralData
      );
      this.setStudentPreRegistryValidations(_numbers);
      this.setInvalidTabs(_numbers);
    },
    setInvalidTabs(tabNumbers) {
      this.$emit('set-invalid-tabs', tabNumbers, true);
    },
    refreshContactPerson() {
      if (this.registerInfo.motherIsPrincipal) {
        this.info.contactName = `${this.registerInfo.motherName} ${
          this.registerInfo.motherLastName
        } ${this.registerInfo.motherSecondLastName ?? ''}`;
        this.info.contactEmail = this.registerInfo.motherEmail;
        this.info.contactTelephone = this.registerInfo.motherPhoneNumber;
        this.info.contactRelationCode = PARENT_TYPE.MOTHER;
        this.selectedRelationship = this.relationships.find(
          (x) => x.id === PARENT_TYPE.MOTHER
        );
      } else if (this.registerInfo.fatherIsPrincipal) {
        this.info.contactName = `${this.registerInfo.fatherName} ${
          this.registerInfo.fatherLastName
        } ${this.registerInfo.fatherSecondLastName ?? ''}`;
        this.info.contactEmail = this.registerInfo.fatherEmail;
        this.info.contactTelephone = this.registerInfo.fatherPhoneNumber;
        this.info.contactRelationCode = PARENT_TYPE.FATHER;
        this.selectedRelationship = this.relationships.find(
          (x) => x.id === PARENT_TYPE.FATHER
        );
      } else if (this.custodianModel.isPrincipal) {
        const contactFullname = `${this.custodianModel.name ?? ''} ${this
          .custodianModel.lastName ?? ''} ${this.custodianModel
          .secondLastName ?? ''}`;
        this.info.contactName = contactFullname.trim();
        this.info.contactEmail = this.custodianModel.email;
        this.info.contactTelephone = this.custodianModel.phoneNumber;
        this.info.contactRelationCode = PARENT_TYPE.CUSTODIAN;
        this.selectedRelationship = this.relationships.find(
          (x) => x.id === PARENT_TYPE.CUSTODIAN
        );
      }
    },
  },
  async mounted() {
    this.$ApiGet('/api/schools/municipalities').then((res) => {
      this.municipality = res.data;
    });
    this.$nextTick(async () => {
      await this.loadInfo();
    });

    this.resources = await resourcesService.LoadValidationMessages(['21084']);
    studentService
      .getstudentdetails({
        regStudentId: this.regStudentId,
        studentSieId: this.studentSieId,
      })
      .then(({ data }) => {
        this.registerInfo = data;
        this.custodianModel = {
          name: data.custodianName,
          lastName: data.custodianLastName,
          secondLastName: data.custodianSecondLastName,
          occupation: data.custodianOccupation,
          email: data.custodianEmail,
          phoneNumber: data.custodianPhoneNumber,
          createAccountPortal: data.createAccountCustodianPortal,
          isPrincipal: data.custodianIsPrincipal,
        };
      });
  },
};
</script>

<style scoped lang="scss">
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.custom-wizard-question {
  background: transparent;
  margin-left: 15px;
  margin-right: 10px;
}

::v-deep .question-box {
  display: none;
}

::v-deep .question-line {
  padding-left: 0px;
}

::v-deep .question-line p {
  padding-left: 0px !important;
}

::v-deep .item-pane {
  padding-left: -40px !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  background: transparent;
}

.custom-section-title {
  margin-right: 12px;
  font-weight: bold;
}

.checkbox-top-spacing {
  margin-top: 25px;
}

.error-custom {
  margin-top: -28px !important;
  margin-left: 10px !important;
}
.label-design {
  font-size: 14px;
  color: #727272;
}
.container-label {
  margin-bottom: 5px;
}

@media screen and (max-width: 768px) {
  ::v-deep .custom-wizard-question {
    .question-box {
      display: none !important;
    }
    .question-box-content {
      display: unset !important;
      .custom-radio-container {
        margin-left: 40px !important;
      }
    }
  }
}

::v-deep .custom-wizard-question {
  .question-box-content {
    .custom-radio-container {
      margin-right: -8px !important;
    }
  }
}

::v-deep .custom-input-read {
  .position-relative {
    position: relative !important;
    right: 16px;
  }
}
::v-deep .custom-input-edit {
  .position-relative {
    position: relative !important;
  }
}
</style>
